module.exports = __webpack_public_path__ + "static/media/background.58f16e3d.jpg";